module.exports = __webpack_public_path__ + "static/media/Flowchart_Division_with_Contact_Inhibition.b39818fd.png";